// TODO - deprecate react-toastify
import React from "react"
import { ToastContainer } from "react-toastify"
import toastCloseButton from "../Icons/svgs/toast-close-icon.svg"

/**
 * TODO - Deprecate
 * Replacing with shadcn/ui toast
 */
const CloseButton = () => <img src={toastCloseButton} alt="toast-close-buton" />
const OldToaster = () => (
  <ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    closeButton={CloseButton}
  />
)

export default OldToaster
